export const TransactionTypes = {
  EMPLOYEE: "EMPLOYEE_SALARY",
  WORKER: "WORKER_PAYMENT",
  VENDOR: "VENDOR_PAYMENT",
  SUBCONTRACTOR: "SUBCONTRACTOR_PAYMENT",
  CLIENT_RECEIPT: "CLIENT_RECEIPT",
  LOAN_DISBURSEMENT: "LOAN_DISBURSEMENT",
  LOAN_REPAYMENT: "LOAN_REPAYMENT",
  EXPENSE_PAYMENT: "EXPENSE_PAYMENT",
  PG_DEPOSIT: "PG_DEPOSIT",
  PG_RELEASE: "PG_RELEASE",
  CAPITAL_ADDITION: "CAPITAL_ADDITION",
  CAPITAL_WITHDRAWAL: "CAPITAL_WITHDRAWAL",
  ACCOUNT: "ACCOUNT_TRANSACTION",
  USER: "ACCOUNT_TRANSACTION",
  OTHER: "OTHER",
};
